import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { EpcotConfig } from '@frontend/sports/common/client-config-data-access';
import { UserService } from '@frontend/sports/user/feature';
import { UserEvent, UserLoginEvent } from '@frontend/vanilla/core';
import { Observable, map, startWith } from 'rxjs';

@Component({
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export abstract class BaseBalanceHeaderComponent {
    @HostBinding('class.epcot') get includedClass(): boolean {
        return this.isEpcot;
    }

    protected readonly isEpcot: boolean;
    protected readonly isAuthenticated$: Observable<boolean>;

    protected constructor(userService: UserService, epcotConfig: EpcotConfig) {
        this.isAuthenticated$ = userService.onAuthenticationChange$.pipe(
            map((event: UserEvent) => event instanceof UserLoginEvent),
            startWith(userService.isAuthenticated),
            takeUntilDestroyed(),
        );
        this.isEpcot = epcotConfig.isEnabled;
    }
}
